export default __webpack_public_path__ + "static/media/goshen21.0d032d5e.jpg";